export const baseUrl = 'egiro';
export const baseMockUrl = 'egiro-mock';

export const ApiEGiro = {
  History: `${baseUrl}/history`,
  Retrieve: `${baseUrl}/retrieve`,
  BankList: `${baseUrl}/bank-list`,
  // BU-20433 - nric moved out of the query string into the request body; the other params here
  // aren't sensitive and stay as-is.
  CreateNewClientEGiro: (applicantBankCode: string, ddaRefNo: string) =>
    `${baseUrl}/create?applicantBankCode=${applicantBankCode}&ddaRefNo=${ddaRefNo}`,
  CreateNewLovedOneEGiro: (applicantBankCode: string, ddaRefNo: string, lovedOneId: string, relationShip: string) =>
    `${baseUrl}/create?applicantBankCode=${applicantBankCode}&ddaRefNo=${ddaRefNo}&lovedOneId=${lovedOneId}&relationship=${relationShip}`,
  Cancel: (ddaRefNo: string, boTransactionRefNo: string) =>
    `${baseUrl}/cancel?boDDARefNo=${ddaRefNo}&boTransactionRefNo=${boTransactionRefNo}`,
  CreateNewClientEGiroTriggerMock: (
    consent: boolean,
    clientID: string,
    requestID: string,
    boDDARefNo: string,
    boTransactionRefNo: string
  ) =>
    `${baseMockUrl}/create/trigger?consent=${consent}&requestID=${requestID}&clientID=${clientID}&boTransactionRefNo=${boTransactionRefNo}&boDDARefNo=${boDDARefNo}`,
  CancelEGiroTriggerMock: (
    consent: boolean,
    clientID: string,
    requestID: string,
    boDDARefNo: string,
    boTransactionRefNo: string
  ) =>
    `${baseMockUrl}/cancel/trigger?consent=${consent}&requestID=${requestID}&clientID=${clientID}&boTransactionRefNo=${boTransactionRefNo}&boDDARefNo=${boDDARefNo}`,
  // BU-20433 - was ?nric=... in the query string; nric now travels in the POST body.
  GenerateDDARefNo: `${baseUrl}/generateDDARefNo`,
  UpdateStatus: (boDDARefNo: string, boTransactionRefNo: string) =>
    `${baseUrl}/status?boDDARefNo=${boDDARefNo}&boTransactionRefNo=${boTransactionRefNo}`
};
